import {_} from 'lodash';
import * as ko from "knockout";
import {TMessageType} from "./index";

export interface IErrorMessage {
    id: any
    message: KnockoutObservable<string | null>
    type: KnockoutObservable<TMessageType>
    show: KnockoutObservable<boolean | null>
}

export class ErrorTrackerManager {
    obj: { [key: string]: ErrorTracker } = {};

    add(key: string) {
        this.obj[key] = new ErrorTracker();
    }

    dispose(key: string) {
        delete this.obj[key];
    }

    get(key: string): ErrorTracker {
        if (!this.obj[key]) {
            this.add(key);
        }
        return this.obj[key]!;
    }
}

export class ErrorTracker {

    arr: KnockoutObservableArray<IErrorMessage> = ko.observableArray<IErrorMessage>([]);

    add(id: any, type: TMessageType = "warning"): IErrorMessage {
        const item = {
            id: id,
            message: ko.observable<string | null>(null),
            type: ko.observable(type),
            show: ko.observable<boolean | null>(null)
        };
        this.arr.push(item);
        return item;
    }

    update(show: boolean, id: any, message: string = "", type: TMessageType = "warning") {
        let item = this.get(id);
        if (!item) {
            item = this.add(id, type);
        }
        item.show(show);
        if (show) {
            item.message(message);
        }
    }

    get(id: any): IErrorMessage | undefined {
        return this.arr().find((obj: IErrorMessage) => obj.id === id);
    }

    isValid(id?: any): boolean {
        if (id) {
            return !this.get(id)?.show();
        }
        return this.arr().every(o => !o.show());
    }

    private pending!: number[];

    startPending(...ids: any[]): PendingErrorTracker {
        const ret = new PendingErrorTracker();
        ids?.forEach(id => ret.update(false, id));
        return ret;
    }

    endPending(obj: PendingErrorTracker) {
        obj.getAll().forEach(o => {
            this.update(o.show, o.id, o.message);
        })
    }

}

interface ITrackerUpdate {
    show: boolean,
    id: any
    message: string
}

export class PendingErrorTracker {
    private arr: ITrackerUpdate[] = [];

    update(show: boolean, id: any, message: string = '') {
        this.arr.push({show, id, message});
    }

    getAll(): ITrackerUpdate[] {
        const ret = _(this.arr).groupBy((o: ITrackerUpdate) => o.id?._id ?? o.id).toArray().value();
        return ret.map((arr: ITrackerUpdate[]) => {
            return arr.find((o: ITrackerUpdate) => o.show) ?? arr[0];
        })
    }

    isValid(): boolean {
        return !this.arr.find(o => o.show);
    }
}
